import { Tooltip } from '../../../../shared/components/text/tooltip/Tooltip'
import { IconInfringement } from '../../../../shared/components/icons/IconInfringement'
import React from 'react'

interface LastCheckCellProps {
  last_check: string
  is_last_infringement?: boolean
}

export const LastCheckCell = ({ last_check, is_last_infringement }: LastCheckCellProps) => {
  return (
    <div className={'flex items-center gap-[6px]'}>
      <Tooltip
        arrowPointAtCenter
        placement='topLeft'
        title='Last check detected potential policy infringements'
      >
        <div
          className={`-ml-[22px] h-[16px] w-[16px] rounded-full border-[1px] border-[#FFADC5] ${
            !is_last_infringement && 'invisible'
          }`}
        >
          <IconInfringement color={'#FFADC5'} />
        </div>
      </Tooltip>
      {last_check}
    </div>
  )
}
